<template>
  <div class="order-container">
    <div class="head van-hairline--bottom">
      <div class="tit">我的订单</div>
      <div
        class="read-more"
        @click="
          $router.push({
            name: 'Order',
            query: { active: 0, backRoute: 'Mine' },
          })
        "
      >
        查看全部订单
        <img :src="require('@/assets/setting/箭头1.svg')" alt="" />
      </div>
    </div>
    <div class="statistics">
      <div
        class="item"
        @click="
          $router.push({
            name: 'Order',
            query: { active: 1, backRoute: 'Mine' },
          })
        "
      >
        <Badge :content="orderNumber.initialTotal || ''" class="img">
          <img :src="require('@/assets/mine/待付款.svg')" alt=""
        /></Badge>
        <div class="tit">待付款</div>
      </div>
      <div
        class="item"
        @click="
          $router.push({
            name: 'Order',
            query: { active: 2, backRoute: 'Mine' },
          })
        "
      >
        <Badge :content="orderNumber.paidTotal || ''" class="img">
          <img :src="require('@/assets/mine/待发货.svg')" alt="" />
        </Badge>
        <div class="tit">待发货</div>
      </div>
      <div
        class="item"
        @click="
          $router.push({
            name: 'Order',
            query: { active: 3, backRoute: 'Mine' },
          })
        "
      >
        <Badge :content="orderNumber.shippedTotal || ''" class="img">
          <img :src="require('@/assets/mine/待收货.svg')" alt="" />
        </Badge>
        <div class="tit">待收货</div>
      </div>
      <div
        class="item"
        @click="
          $router.push({
            name: 'Order',
            query: { active: 4, backRoute: 'Mine' },
          })
        "
      >
        <div class="img">
          <img :src="require('@/assets/mine/已完成.svg')" alt="" />
        </div>
        <div class="tit">已完成</div>
      </div>
      <div
        class="item"
        @click="
          $router.push({
            name: 'Order',
            query: { active: 5, backRoute: 'Mine' },
          })
        "
      >
        <div class="img">
          <img :src="require('@/assets/mine/售后.svg')" alt="" />
        </div>
        <div class="tit">售后</div>
      </div>
    </div>
    <div class="logistics">
      <div v-if="orderNumber.express" class="logistics-content">
        <div
          class="img rounded"
          :style="{
            backgroundImage: 'url(' + orderNumber.express.goodsInfoImg + ')',
          }"
        ></div>
        <div class="value ml-2">
          <div class="tit van-ellipsis">
            {{ orderNumber.express.goodsInfoName }}
          </div>
          <div v-if="orderNumber.express.data" class="desc van-ellipsis">
            {{ orderNumber.express.data[0].context }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderNumber } from "../webApi";
import { Badge } from "vant";

export default {
  components: { Badge },
  created() {
    getOrderNumber({ type: false }).then(({ data }) => {
      this.orderNumber = data;
    });
  },
  data() {
    return {
      orderNumber: { express: {} },
    };
  },
};
</script>

<style lang="less" scoped>
.order-container {
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.14);
  border-radius: 16px;
  margin-bottom: 16px;
  .head {
    display: flex;
    justify-content: space-between;
    padding: 20px 18px;
    .tit {
      font-size: 24px;
      line-height: 34px;
    }
    .read-more {
      font-size: 24px;
      line-height: 34px;
      align-items: center;
      display: flex;
      color: #aeaeae;
      img {
        display: inline-block;
        height: 18px;
        margin-left: 20px;
      }
    }
  }
  .statistics {
    padding: 18px 0 0;
    display: flex;
    .item {
      width: 20%;
      display: flex;
      flex-direction: column;
      .img {
        width: 52px;
        margin: 0 auto;
      }
      .tit {
        padding-top: 6px;
        font-size: 20px;
        text-align: center;
        line-height: 28px;
      }
    }
  }
  .logistics {
    padding: 20px;
    .logistics-content {
      display: flex;
      padding: 20px;
      background: #f7f7f7;
      border-radius: 16px;
      .img {
        width: 80px;
        height: 80px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
      }
      .value {
        text-align: left;
        flex: 1;
        min-width: 0;
        .tit {
          font-size: 20px;
          line-height: 28px;
        }
        .desc {
          margin-top: 12px;
          font-size: 20px;
          color: #aeaeae;
          line-height: 28px;
        }
      }
    }
  }
}
</style>